import React from 'react';
import Hero from "../Components/Hero";
import SectionTwo from "../Components/SectionTwo";
import SectionFour from "../Components/SectionFour";
import SectionFive from "../Components/SectionFive";
import SectionSix from "../Components/SectionSix";
import SectionSeven from "../Components/SectionSeven";
import SectionEight from "../Components/SectionEight";
import SectionThree from "../Components/SectionThree";


const Home = () => {

    return(
        <>
            <Hero/>
            <SectionTwo/>
            <SectionThree/>
            <SectionFour/>
            <SectionFive/>
            <SectionSix/>
            <SectionSeven/>
            <SectionEight/>
        </>
    );
}

export  default Home